






import * as Vue2Leaflet from 'vue2-leaflet';

import { Vue, Component } from 'vue-property-decorator';

@Component({
  extends: Vue2Leaflet.LPopup,
})
export default class ExtendedPopup extends Vue {
  /*
    ATTENTION: This component has been implemented as Leaflet doesn't allow
    populating properly popups with dyanmic contents. Extending the popup
    class allows us to handle dynamic datas in a better way for async calls.
  */
}
